module.exports = __webpack_public_path__ + "videos/alter-ego_16-9.d0cd6cd.mp4";